(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avyro-bundle-product"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('avyro-bundle-product'))customElements.define('avyro-bundle-product',class extends HTMLElement{
    connectedCallback(){
      const data=JSON.parse(this.querySelector('[data-bundle-data]').textContent);
      const selects=[...this.querySelectorAll('[data-bundle-option]')];
      const input=this.querySelector('[data-bundle-variant]');
      const button=this.querySelector('[type=submit]');
      const error=this.querySelector('[role=status]');
      const enabled=this.dataset.enabled==='true';
      const priceFormatter=new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency:data.currency||'AUD',currencyDisplay:'narrowSymbol'});
      const update=()=>{
        const choices=selects.map(select=>select.value);
        const variant=data.variants.find(item=>item.options.every((option,index)=>option===choices[index]));
        input.disabled=!variant;
        if(variant)input.value=String(variant.id);
        button.disabled=!enabled||!variant||!variant.available;
        error.hidden=!!variant&&variant.available;
        error.textContent=error.hidden?'':this.dataset.unavailable;
        const launch=enabled&&this.dataset.launch==='true'&&Date.now()<Date.parse('2026-10-25T12:59:00Z');
        if(variant)this.querySelector('[data-bundle-price]').textContent=priceFormatter.format((launch?11000:variant.price)/100)+' '+(data.currency||'AUD');
        this.querySelector('[data-bundle-saving]').textContent=launch?data.savingLaunch:data.savingRegular;
        this.querySelector('[data-benefit-saving]').textContent=launch?data.savingLaunch:data.savingRegular;
        this.querySelector('.avyro-bundle-terms').hidden=!launch;
      };
      selects.forEach(select=>select.addEventListener('change',update));
      this.querySelector('form').addEventListener('submit',event=>{update();if(button.disabled)event.preventDefault();});
      update();let previousLaunch=this.dataset.launch==='true'&&Date.now()<Date.parse('2026-10-25T12:59:00Z');this.timer=setInterval(()=>{const currentLaunch=this.dataset.launch==='true'&&Date.now()<Date.parse('2026-10-25T12:59:00Z');if(currentLaunch!==previousLaunch){previousLaunch=currentLaunch;update();}},1000);
    }
    disconnectedCallback(){clearInterval(this.timer);}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avyro-launch-bars"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('avyro-launch-bars')) customElements.define('avyro-launch-bars', class extends HTMLElement {
  connectedCallback() {
    const promo = this.querySelector('.avyro-promo');
    const end = Date.parse(this.dataset.deadline);
    const tick = () => {
      const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (!remaining) { window.location.reload(); clearInterval(this.timer); return; }
      const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
      Object.entries(values).forEach(([key,value]) => { this.querySelector('[data-time="'+key+'"]').textContent = String(value).padStart(2,'0'); });
    };
    if (promo) { tick(); this.timer = setInterval(tick, 1000); }
    this.querySelector('button').onclick = (event) => {
      const paused = this.querySelector('.avyro-marquee').classList.toggle('is-paused');
      event.currentTarget.setAttribute('aria-pressed', String(paused));
      event.currentTarget.setAttribute('aria-label', paused ? this.dataset.resume : this.dataset.pause);
      event.currentTarget.textContent = paused ? '▷' : 'Ⅱ';
    };
  }
  disconnectedCallback() { clearInterval(this.timer); this.querySelector('button').onclick = null; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
